import { createContext } from "react";
import useAgentLocationSummaries from "../hooks/data/useAgentLocationSummaries";

export interface IAgentLocationsContext extends ReturnType<typeof useAgentLocationSummaries> {

};

const AgentLocationsContext = createContext<IAgentLocationsContext>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default AgentLocationsContext